var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "list-actus" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("section", { staticClass: "filters" }, [
          _c(
            "ul",
            { staticClass: "filtre-taaf-rnn" },
            _vm._l(_vm.taxoEntities, function (item, index) {
              return _c("li", { key: index }, [
                _c(
                  "a",
                  {
                    class: { active: _vm.form.site === item.id },
                    attrs: { href: "" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.filtreSite(item.id)
                      },
                    },
                  },
                  [
                    _c("span", { staticClass: "pastille", class: item.slug }),
                    _vm._v(
                      "\n                        " +
                        _vm._s(item.label) +
                        "\n                    "
                    ),
                  ]
                ),
              ])
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "form",
            {
              attrs: { action: "" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.formSubmit()
                },
              },
            },
            [
              _c("div", { staticClass: "form-item word-search" }, [
                _c("span", {
                  staticClass: "icon-arrow-right",
                  on: {
                    click: function ($event) {
                      return _vm.formSubmit()
                    },
                  },
                }),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.form.word,
                      expression: "form.word",
                    },
                  ],
                  attrs: {
                    type: "text",
                    name: "word",
                    id: "word",
                    placeholder: "Recherche par mot-clés",
                  },
                  domProps: { value: _vm.form.word },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.form, "word", $event.target.value)
                    },
                  },
                }),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm.loading
          ? _c("div", { staticClass: "loader-wrap" }, [_vm._m(0)])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "transition-group",
          {
            staticClass: "list-wrap",
            attrs: { tag: "div", css: false },
            on: { "before-enter": _vm.beforeEnter, enter: _vm.enter },
          },
          _vm._l(_vm.result, function (item, index) {
            return _c(
              "a",
              {
                key: "key_" + index,
                staticClass: "item",
                class: { focus: _vm.form.page === 1 && index === 0 },
                attrs: { href: item.url, "data-index": index },
              },
              [
                _c("div", {
                  staticClass: "img",
                  style: "background-image: url(" + item.imgUrl + ")",
                }),
                _vm._v(" "),
                _c("div", { staticClass: "description" }, [
                  _c("h2", {
                    staticClass: "titre",
                    domProps: { innerHTML: _vm._s(_vm.getTitle(item, index)) },
                  }),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "summary",
                    domProps: { innerHTML: _vm._s(_vm.getHtml(item, index)) },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "footer-item" }, [
                    _c("div", { class: "bar " + item.type }),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "date",
                      domProps: { innerHTML: _vm._s(item.date) },
                    }),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _vm.result && _vm.result.length === 0
          ? _c("p", { staticClass: "no-results" }, [_vm._t("no-results")], 2)
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "clearfix" }),
        _vm._v(" "),
        !_vm.loading && _vm.showPagination
          ? _c("pagination", {
              attrs: {
                pagination: _vm.pagination,
                params: _vm.form,
                offset: 2,
              },
              on: { paginate: _vm.formSubmit },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-ring" }, [
      _c("div"),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div"),
      _vm._v(" "),
      _c("div"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }